import { createContext, useContext, useMemo } from 'react';

import type { PropsWithChildren } from 'react';

export type PopupContextValue = {
  zIndex?: number;
} | null;

export const PopupContext = createContext<PopupContextValue>(null);

export const PopupContextProvider = (
  props: {
    zIndex?: number;
  } & PropsWithChildren,
) => {
  const { zIndex, children } = props;

  const value = useMemo(() => ({ zIndex }), [zIndex]);

  return <PopupContext.Provider value={value}>{children}</PopupContext.Provider>;
};

export const usePopupContext = () => {
  return useContext(PopupContext);
};
